"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineDrawerSize = void 0;
/**
 * Blueprint has its own DrawerSize enum that they export but we're rolling our own
 * that has appropriate sizes for our use cases
 */
var InlineDrawerSize = /*#__PURE__*/function (InlineDrawerSize) {
  InlineDrawerSize["SMALL"] = "480px";
  InlineDrawerSize["MEDIUM"] = "600px";
  InlineDrawerSize["LARGE"] = "800px";
  return InlineDrawerSize;
}({});
exports.InlineDrawerSize = InlineDrawerSize;